<template>
  <div class="h-full flex flex-col" v-if="news !== null">
    <h1 class="text-4xl mb-5">{{ news.title }}</h1>
    <div id="page" @scroll="$bus.$emit('scroll')" class="content flex-grow">
      <div class="section">
        <div class="scale-grid flex max-h-50 flex-row flex-wrap">
          <tile
            :class="[mobile ? 'w-full' : 'w-1/3']"
            :key="news.main_image.url"
            :image="news.main_image.url"
            :scale="false"
            :info="false"
          />

          <div :class="[mobile ? 'w-full' : 'w-2/3', 'px-3 flex pb-6']">
            <div class="tile-content">
              <div class="fill-content mb-3">
                <p class="mb-3">
                  {{ formatDate(news.created_at) }}
                </p>
                <p class="mb-3">{{ news.description }}</p>
                <p>When: {{ formatDate(news.date) }}</p>
                <p>Where: {{ newsLocation(news) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <tile
              :class="[mobile ? 'w-full' : 'w-1/3']"
            v-for="(image, index) in news.support_images"
            :key="image.url"
            @click="() => $refs.supportImages.open(index)"
            :image="image.url"
            :info="false"
          />

          <ImageLightbox ref="supportImages" :images="news.support_images" />
        </div>
      </div>
    </div>
    <button @click="goTo(news.url, '_blank')" class="action-btn w-full bg-white-25 hover:bg-dm py-2 rounded-full">
      See More
    </button>
  </div>
</template>

<script>
import SingleImage from '@components/details/SingleImage';
import ImageSlides from '@components/details/ImageSlides';
import Icon from '@components/Icon';
import Tile from '@components/Tile';
import ImageLightbox from '@components/ImageLightbox';

export default {
  name: 'news-detail',
  components: { ImageLightbox, Tile, ImageSlides, SingleImage, Icon },
  data() {
    return {
      news: null,
      loading: true,
      mobile: this.$store.state.screenSize === 1,
    };
  },
  watch: {
    '$store.state.screenSize': function(size) {
      this.mobile = size === 1;
    },
  },
  computed: {},
  mounted() {
    this.getNews(this.$route.params.slug)
      .then(({ data }) => {
        this.news = data;
        this.loading = false;
      })
      .catch(e => {
        if (e.response.status === 404) {
          this.$router.push('/404');
        }
      });

    this.$bus.$on('prev', () => {
      this.$router.push({
        name: `news-detail`,
        params: { slug: this.news.nav.prev },
      });
    });

    this.$bus.$on('next', () => {
      this.$router.push({
        name: `news-detail`,
        params: { slug: this.news.nav.next },
      });
    });

    this.$bus.$on('back', () => {
      this.$router.push({
        name: 'news',
      });
    });
  },

  beforeDestroy() {
    this.$bus.$off('prev');
    this.$bus.$off('next');
    this.$bus.$off('back');
  },

  methods: {
    getNews(slug) {
      return window.axios.get(`/api/news/${slug}?include=nav`);
    },
    newsLocation(news) {
      if (news.is_online) {
        return `${news.online_platform}, Online`;
      } else {
        return `${news.city}, ${news.country}`;
      }
    },
  },
};
</script>
<style scoped lang="scss">
#router-cont {
  padding-bottom: 7.5rem !important;
}
</style>
